import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { orderReceiptsDeclarationComponents, OrderReceiptsRoutingModule,  SerialnumberViewComponent,  
  TechnicianReceivingFaultyItemModalComponent,  VarianceViewComponent
} from '@inventory/components/order-receipts';

import { NgxPrintModule } from 'ngx-print';
import { SignaturePadModule } from 'ngx-signaturepad';
import { BarcodePrinterModule } from '../barcode-printer/barcode-printer/barcode-printer.module';
import { NgxBarcode6Module } from 'ngx-barcode6';
@NgModule({
  declarations: [ ...orderReceiptsDeclarationComponents],
  imports: [
    CommonModule,
    OrderReceiptsRoutingModule,
    LayoutModule,
    MaterialModule,
    SharedModule,
    SignaturePadModule,
    NgxBarcode6Module,
    NgxPrintModule,
    BarcodePrinterModule,
    // NgxBarCodePutModule
  ],
  entryComponents: [ SerialnumberViewComponent, VarianceViewComponent, TechnicianReceivingFaultyItemModalComponent],
})
export class OrderReceiptsModule { }
